(function () {
  const MAX_ITEMS = 10;
  const STORAGE_KEY = 'recently_viewed';

  function saveRecentlyViewed(id, handle) {
    if (!id || !handle) return;
    try {
      let list = [];
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) list = JSON.parse(raw);
        if (!Array.isArray(list)) list = [];
      } catch (_) {
        list = [];
      }
      const idStr = String(id);
      list = list.filter(function (item) {
        return item && String(item.id) !== idStr;
      });
      list.unshift({ id: idStr, handle: String(handle) });
      list = list.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (_) {}
  }

  const el = document.getElementById('recently-viewed-data');
  if (el && el.dataset.productId && el.dataset.productHandle) {
    saveRecentlyViewed(el.dataset.productId, el.dataset.productHandle);
  }
})();
